import React, { useEffect, useState } from "react";
import { Button, Spin, Divider } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SectionHeader from "../../components/global/SectionHeader";
import { Tooltip } from "antd"
import { useNavigate, useParams } from "react-router";
import Layout from "../../components/global/layout";
import { BsArrowLeftSquare } from "react-icons/bs";
import ApiClient from "../../methods/api/apiClient";


const ViewReview = () => {
  const [loading, setloading] = useState(false);
  const [data, setData] = useState()
  const naviagte = useNavigate();
  let tl = localStorage.getItem('tl')

  let { id } = useParams()

  useEffect(() => {
    getReview();

  }, []);


  const renderSubmitBack = () => {
    naviagte(-1)
  }
  const getReview = () => {
    setloading(true);
    let data = {
      id: id
    }
    try {

      ApiClient.get('project-review', data).then((res) => {
        if (res.success) {
          setData(res.data)
        }

      })
      setloading(false);
    } catch (e) {
      setloading(false);
    }
  };


  return (
    <Layout>
      <div className="">
        <div className="main-content">
          <div className="headings">
            <div className="d-flex align-items-center gap-3">
              <Tooltip title="Back Button">
                <p
                  onClick={renderSubmitBack}
                  className="pointer text-white  fs-3"
                >
                  <BsArrowLeftSquare />
                </p>
              </Tooltip>
              <SectionHeader title="Project Detail" />
            </div>
          </div>

          <div className="section ">
            <Spin spinning={loading}>
              <div className="">
                <div className=" ">
                  <h6 className="detail-header"> <Divider orientation="left">Basic Details</Divider></h6>
                  <div className="row m-0">
                    <div className="col-md-6">
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Project Name<span>:</span></label> <span>  {data?.ProjectName} </span>                     </li>
                    </div>
                    {tl == 'false' ? <>
                      <div className="col-md-6">
                        <li class="view_parent align-items-baseline">
                          <label className="detail-text text-bold text-capitalize pb-0">Reviewed by<span>:</span></label> <span> {data?.addedByName} </span>                      </li>
                      </div></> : ''
                    }
                    {tl == 'true' ? <>
                      <div className="col-md-6">
                        <li class="view_parent align-items-baseline">
                          <label className="detail-text text-bold text-capitalize pb-0">Reviewed to<span>:</span></label> <span> {data?.EmployeeName} </span>                      </li>
                      </div>
                    </> : ''
                    }
                  </div>
                  <h6 className="detail-header"> <Divider orientation="left">Description</Divider></h6>
                  <div className=""
                          dangerouslySetInnerHTML={{ __html: data?.description }}
                        />
                  {/* <div>
                    <li class="view_parent align-items-baseline">
                      <label className="detail-text text-bold text-capitalize pb-0">Project Name</label>
                      <div className="mt-2">
                        <p className="text-capitalize">{data?.ProjectName}</p>
                      </div>
                    </li>
                  </div> */}

                  {/* {tl == 'false' ? <>
                    <div>
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Reviewed by</label>
                        <div className="mt-2">
                          <p className="text-capitalize"> {data?.addedByName}</p>
                        </div>
                      </li>
                    </div></> : ''

                  }

                  {tl == 'true' ? <>
                    <div>
                      <li class="view_parent align-items-baseline">
                        <label className="detail-text text-bold text-capitalize pb-0">Reviewed to</label>
                        <div className="mt-2">
                          <p>{data?.EmployeeName
                          }</p>
                        </div>
                      </li>
                    </div>
                  </> : ''
                  } */}
                  {/* <div>
                    <li class="view_parent align-items-baseline">
                      <label className="detail-text text-bold text-capitalize pb-0">Description</label>
                      <div className="mt-2">
                        <div className=""
                          dangerouslySetInnerHTML={{ __html: data?.description }}
                        />
                      </div>
                    </li>
                  </div> */}

                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div >
    </Layout >
  );
};

export default ViewReview;
